import type { OperationsApi } from './operationsApi';
import { BrowserStateRepository } from './storageRepository';
import { MockApi } from './mockApi';
import { HttpApi } from './httpApi';

let csrfToken = '';
export function updateApiSession(next: { csrfToken?: string }) { csrfToken = next.csrfToken ?? ''; }
export function createOperationsApi(): OperationsApi {
  const mode = import.meta.env.VITE_API_MODE ?? 'mock';
  if (mode === 'http') return new HttpApi(import.meta.env.VITE_API_BASE_URL ?? '/api', () => csrfToken);
  return new MockApi(new BrowserStateRepository());
}
